import apiClient from "../_helpers/api-client";
import { authHeader } from "../_helpers";
import moment from "moment";

export const userService = {
  login,
  logout,
  getAll,
  getCurrentUserInfo
};

function login({ username, password, remember }) {
  return apiClient
    .post("/api/v4/auth/login?realm=Callcenter", {
      client_id: username,
      client_secret: password
    })
    .then(user => {
      // login successful if there's a jwt token in the response
      user.expires_on = moment()
        .add(user.expires_in, "s")
        .toDate();
      if (user.access_token && remember) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem(
          "remember",
          JSON.stringify({
            userNameToRemember: username
          })
        );
      } else if (user.access_token) {
        sessionStorage.setItem("user", JSON.stringify(user));
        localStorage.removeItem("remember");
      } else {
        localStorage.removeItem("remember");
      }

      apiClient.defaults.headers.common = authHeader();

      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  sessionStorage.removeItem("user");
}

function getAll() {
  return apiClient.get("/api/v4/users");
}

function getCurrentUserInfo() {
  return apiClient.get("/api/v4/auth/userinfo");
}
